/* Default project array */
export const projects = [
  { id: "1", name: "LMS" },
  { id: "2", name: "eIDSR" },
  { id: "3", name: "ORMS" },
];

/* Default purpose array */
export const purposes = [
  { id: "1", name: "Transportation" },
  { id: "2", name: "Internet" },
  { id: "3", name: "Lunch" },
];

/* Default currency array */
export const currencies = [
  { id: "1", name: "USD" },
  { id: "2", name: "LRD" },
];

/*Default monthlyRepaymentRates*/
export const monthlyRepaymentRates = [
  { id: "1", name: "10" },
  { id: "2", name: "22" },
  { id: "3", name: "33" },
];

/* Default request types */
export const requestTypes = [
  {
    id: "4",
    name: "Executive",
    path: "/requestmanagement/requesttype/executive",
  },
  {
    id: "3",
    name: "Payment Voucher",
    path: "/requestmanagement/requesttype/payment",
  },
  {
    id: "2",
    name: "Salary Advance",
    path: "/requestmanagement/requesttype/salaryadvance",
  },
  {
    id: "1",
    name: "Loan",
    path: "/requestmanagement/requesttype/loan",
  },
];

// Mapping request types to their endpoints
export const requestTypeRoutes = {
  "Payment Voucher": "/PaymentVoucher",
  Executive: "/Executive",
  "Salary Advance": "/SalaryAdvance",
  Loan: "/Loan",
};
